module.exports = __webpack_public_path__ + "static/img/before_64.22734f03.png";